import { type LazyMutationCommand } from './types';

export const LAZY_DASHBOARD_COMMANDS: LazyMutationCommand[] = [
  { name: 'ADD_VARIABLE', load: () => import('./addVariable').then((module) => module.addVariableCommand) },
  { name: 'REMOVE_VARIABLE', load: () => import('./removeVariable').then((module) => module.removeVariableCommand) },
  { name: 'UPDATE_VARIABLE', load: () => import('./updateVariable').then((module) => module.updateVariableCommand) },
  {
    name: 'LIST_VARIABLES',
    readOnly: true,
    load: () => import('./listVariables').then((module) => module.listVariablesCommand),
  },
  { name: 'ADD_ANNOTATION', load: () => import('./addAnnotation').then((module) => module.addAnnotationCommand) },
  {
    name: 'UPDATE_ANNOTATION',
    load: () => import('./updateAnnotation').then((module) => module.updateAnnotationCommand),
  },
  {
    name: 'REMOVE_ANNOTATION',
    load: () => import('./removeAnnotation').then((module) => module.removeAnnotationCommand),
  },
  {
    name: 'LIST_ANNOTATIONS',
    readOnly: true,
    load: () => import('./listAnnotations').then((module) => module.listAnnotationsCommand),
  },
  { name: 'ENTER_EDIT_MODE', load: () => import('./enterEditMode').then((module) => module.enterEditModeCommand) },
  { name: 'GET_LAYOUT', readOnly: true, load: () => import('./getLayout').then((module) => module.getLayoutCommand) },
  { name: 'ADD_ROW', load: () => import('./addRow').then((module) => module.addRowCommand) },
  { name: 'REMOVE_ROW', load: () => import('./removeRow').then((module) => module.removeRowCommand) },
  { name: 'UPDATE_ROW', load: () => import('./updateRow').then((module) => module.updateRowCommand) },
  { name: 'MOVE_ROW', load: () => import('./moveRow').then((module) => module.moveRowCommand) },
  { name: 'ADD_TAB', load: () => import('./addTab').then((module) => module.addTabCommand) },
  { name: 'REMOVE_TAB', load: () => import('./removeTab').then((module) => module.removeTabCommand) },
  { name: 'UPDATE_TAB', load: () => import('./updateTab').then((module) => module.updateTabCommand) },
  { name: 'MOVE_TAB', load: () => import('./moveTab').then((module) => module.moveTabCommand) },
  { name: 'MOVE_PANEL', load: () => import('./movePanel').then((module) => module.movePanelCommand) },
  { name: 'UPDATE_LAYOUT', load: () => import('./updateLayout').then((module) => module.updateLayoutCommand) },
  { name: 'ADD_PANEL', load: () => import('./addPanel').then((module) => module.addPanelCommand) },
  { name: 'UPDATE_PANEL', load: () => import('./updatePanel').then((module) => module.updatePanelCommand) },
  { name: 'REMOVE_PANEL', load: () => import('./removePanel').then((module) => module.removePanelCommand) },
  {
    name: 'LIST_PANELS',
    readOnly: true,
    load: () => import('./listPanels').then((module) => module.listPanelsCommand),
  },
  {
    name: 'GET_PANEL_ERRORS',
    readOnly: true,
    load: () => import('./getPanelErrors').then((module) => module.getPanelErrorsCommand),
  },
  {
    name: 'GET_DASHBOARD_INFO',
    readOnly: true,
    load: () => import('./getDashboardInfo').then((module) => module.getDashboardInfoCommand),
  },
  {
    name: 'GET_METADATA_ANNOTATIONS',
    readOnly: true,
    load: () => import('./getMetadataAnnotations').then((module) => module.getMetadataAnnotationsCommand),
  },
  {
    name: 'UPDATE_METADATA_ANNOTATIONS',
    load: () => import('./updateMetadataAnnotations').then((module) => module.updateMetadataAnnotationsCommand),
  },
  {
    name: 'UPDATE_DASHBOARD_SETTINGS',
    load: () => import('./updateDashboardSettings').then((module) => module.updateDashboardSettingsCommand),
  },
  { name: 'GET_SPEC', readOnly: true, load: () => import('./getSpec').then((module) => module.getSpecCommand) },
  { name: 'APPLY_SPEC', load: () => import('./applySpec').then((module) => module.applySpecCommand) },
  { name: 'START_BATCH', load: () => import('./history').then((module) => module.startBatchCommand) },
  { name: 'END_BATCH', load: () => import('./history').then((module) => module.endBatchCommand) },
  {
    name: 'GET_LAST_ACTION',
    readOnly: true,
    load: () => import('./history').then((module) => module.getLastActionCommand),
  },
  { name: 'UNDO', load: () => import('./history').then((module) => module.undoCommand) },
  { name: 'REDO', load: () => import('./history').then((module) => module.redoCommand) },
  { name: 'RENDER_PLAN', load: () => import('./renderPlan').then((module) => module.renderPlanCommand) },
  { name: 'END_PLANNING', load: () => import('./endPlanning').then((module) => module.endPlanningCommand) },
  {
    name: 'RELOAD_FROM_SERVER',
    readOnly: true,
    load: () => import('./reloadFromServer').then((module) => module.reloadFromServerCommand),
  },
];
